<script setup lang="ts">
import type { AnchorHTMLAttributes, HTMLAttributes } from 'vue'
import type { RouteLocationRaw } from 'vue-router'

const props = defineProps<{
  class?: HTMLAttributes['class']
  title?: string
  description?: string
  linkLabel?: string
  imageUrl?: string
  iconUrl?: string
  to: RouteLocationRaw
  target?: AnchorHTMLAttributes['target']
  external?: boolean
}>()
</script>

<template>
  <div
    :class="
      cn(
        'lg:flex-1 lg:min-w-[350px] lg:max-w-[450px] border border-outline-variant rounded-xl relative hover:shadow-lg group flex flex-col gap-4 overflow-hidden justify-between bg-surface-container-lowest hover:bg-surface-container-low transition-all duration-300 ease-in-out',
        props.class
      )
    "
  >
    <div class="p-6 flex flex-col gap-3">
      <NuxtImg v-if="iconUrl" :src="iconUrl" class="w-16" />
      <h4 v-if="title" class="text-xl font-bold">{{ title }}</h4>
      <p v-if="description" class="text-on-surface-variant text-lg">
        {{ description }}
      </p>
      <div v-if="linkLabel" class="text-primary flex items-center gap-3">
        <span class="font-semibold">{{ linkLabel }}</span>
        <Icon name="material-symbols:arrow-forward" size="24px" />
      </div>
    </div>
    <NuxtImg v-if="imageUrl" :src="imageUrl" :alt="props.title" />
    <NuxtLink
      :to="to"
      :aria-label="title"
      :target="target"
      class="absolute inset-0"
      :external="external"
    ></NuxtLink>
  </div>
</template>
